import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { useResource } from "@hooks/useResource";

import { getTypeParam, getAdvancedPeriodStringParam } from "@helpers/general";

import BarChartCardWrapper from "../BarChartCardWrapper";
import SpinnerWrapper from "@components/Common/SpinnerWrapper";
import ErrorPage from "@components/Common/ErrorPage";

export default function FamiliesRow({
    type,
    period,
    designation,
}: StatisticsChartsRowsPropsType) {
    const { t } = useTranslation();
    const advancedDate = useSelector(
        (state: {
            advancedDate: {
                startDate: string;
                endDate: string;
            };
        }) => state.advancedDate
    );

    const [data, setData] = React.useState<number[]>([]);
    const [labels, setLabels] = React.useState<string[]>([]);

    const { resourceData, error } = useResource(
        `${
            process.env.REACT_APP_API_V1_URL
        }/dashboard/families?type=${getTypeParam(
            type
        )}&${getAdvancedPeriodStringParam(period, advancedDate)}${
            designation && designation !== "my_favorites"
                ? `&selected=${designation}`
                : ""
        }`
    );

    React.useEffect(() => {
        let localData: number[] = [];
        let localLabels: string[] = [];

        resourceData.data?.forEach((item: any) => {
            localLabels.push(item.designation);
            localData.push(item.value);
        });

        setData(localData);
        setLabels(localLabels);
    }, [resourceData]);

    const familiesInitData: SerieType[] = [
        {
            name: type,
            data: [...data, ...Array(10 - data.length).fill(0)],
        },
    ];

    return (
        <React.Suspense fallback={<SpinnerWrapper />}>
            {error ? (
                <ErrorPage />
            ) : (
                <BarChartCardWrapper
                    title={t("Families")}
                    series={familiesInitData}
                    categories={[
                        ...labels,
                        ...Array(10 - labels.length).fill(""),
                    ]}
                    type={type}
                />
            )}
        </React.Suspense>
    );
}
